module.exports = __webpack_public_path__ + "media/diddy-kong.c9415cf9.wav";